import { useFocusWithin as useMantineFocusWithin } from '@mantine/hooks';

export const useFocusWithin = useMantineFocusWithin;
